import { collect } from 'collect.js';

/**
 * Whether a navigation item should be visible for the current user.
 *
 * Pure recursion over the menu tree (extracted from useNavigation so it can be
 * tested without rendering): hidden items are never shown; top-level items are
 * gated by screen group, nested items by screen; a parent is shown only if at
 * least one of its children is visible.
 *
 * @param predicates { canAccessScreen, canAccessScreenGroup }
 */
export function navItemIsVisible(item, parent, predicates) {
  const { canAccessScreen, canAccessScreenGroup } = predicates;

  if (item.hidden) {
    return false;
  }

  let result = true;

  if (item.key) {
    result = !parent ? canAccessScreenGroup(item.key) : canAccessScreen(item.key);
  }

  if (item.children) {
    result =
      result &&
      collect(item.children)
        .filter((childItem) => navItemIsVisible(childItem, item, predicates))
        .isNotEmpty();
  }

  return result;
}
